// removed by extract-text-webpack-plugin
module.exports = {"loading":"_2Os3Uk9iJc8qYbY1hsyokb","search":"_3sxCUKYoYjM-RLQA_oudVB","label":"_2la0LXPz-5ZkLvdeV5kvHc","container":"GnFkD2WNbiv2Nj-vcsU8K","input":"_3SWE7sEmENz4XJ4xplD3dt","button":"yHCSy9M4b4P_QDCZ6meer","icon":"B6mlWcEGdvVpYkkdTSjWE","search-result-text":"_2KeloCmcs4s00UsIj9ommz","no-results-text":"_34bYQvtfTYLO09AtePIE_W","error":"_2CgKZpFPq9BroYyckxAtOa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ListSearchForm/ListSearchForm.module.scss
// module id = 785
// module chunks = 0